import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintEdi.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintEdi_edi_sftp_queueService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { connection: string, target_path: string, file_content: string, transaction_type?: string }): Promise<{ messages?: any[], success?: boolean }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.connection)) {
      $missingRequiredInParams.push('\'connection\'');
    }
    if (isNil($inParams.target_path)) {
      $missingRequiredInParams.push('\'target_path\'');
    }
    if (isNil($inParams.file_content)) {
      $missingRequiredInParams.push('\'file_content\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

